// Local clocking models for managing local state

import { IGeolocation, IGeoposition } from '../geolocation.model';
import { IAttachment } from './attachment.model';
import { IRepairOrder } from './repairOrder.model';
import { IRepairOrderJob } from './repairOrderJob.model';
import { ITechComment } from './technicianComments.model';

export interface IClockingBase {
  type: ClockingType;
  direction: ClockingDirection;
  technicianCode: string;
  startDateTime?: string;
  endDateTime?: string;
  // If the record is created from the server (via a GET) set to true
  fromServer: boolean;
  // If the clocking was resumed, store this data here
  resumeDateTime?: string;
}

export interface ILabourClocking extends IClockingBase {
  jobData: IRepairOrderJob;
  repairOrder: IRepairOrder;
  details?: ILabourClockingDetails;
  position?: IGeoposition;
  trackDistance?: boolean;
}

export interface IAttendanceClocking extends IClockingBase {
  position: IGeoposition;
}

export enum ClockingType {
  Attendance,
  Labour
}

export enum ClockingDirection {
  Off, On, Break
}

export interface ILabourClockingDetails {
  isAlert: boolean;
  techComment: string;
  closeRo: boolean;
  delayCode: string;
  delayComment: string;
  labourType: string;
  workCategory: string;
  isDiagnostic: boolean;
  distanceLocationsRaw: IGeolocation[];
  distanceRaw: number;
  distanceAccurate: number;
  techComments: ITechComment[];
  attachments: IAttachment[];
}

// Flattened tech clocking models coming from server

export interface ITechClockingDetail {
  technicianCode: string;
  attendanceClocking: ITechClockingAttendance;
  labourClocking: ITechClockingLabour;
}

export interface ITechClockingAttendance {
  startDateTime: string;
  endDateTime?: string;
}

export interface ITechClockingLabour {
  branchCode: string;
  repairOrderNumber: number;
  jobType: string;
  jobCode: string;
  startDateTime: string;
  endDateTime?: string;
  source: string;
  sourceRef: string;
}

export interface IClockingHistory {
  type: ClockingType;
  direction: ClockingDirection;
  branchCode: string;
  repairOrderNumber: number;
  jobType: string;
  jobCode: string;
  clockingDateTime: string;

  // Used for offline sync
  unSync: boolean;
  id?: number;
}

export interface IClockingHistoryAttendance {
  techCode: string;
  lineNumber: number;
  startDateTime: Date;
  endDateTime: Date;
}

export interface IClockingHistoryLabour {
  branchCode: string;
  repairOrderNumber: number;
  jobCode: string;
  jobType: string;
  techCode: string;
  sequence: number;
  startDateTime: Date;
  endDateTime: Date;
}
